module.exports = __webpack_public_path__ + "img/industry1.f62d39e.jpg";